import React from "react";
import { reportSiteBuilderBladeError } from "../utils/renderer/createSiteBuilderBladeRegistry";
import { ErrorBlade } from "./ErrorBlade";

type BladeErrorProps = {
  showBladeDiagnostics: boolean;
  index: number;
  bladeType?: string;
  children?: React.ReactElement;
};

export class BladeErrorBoundary extends React.Component<
  BladeErrorProps,
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    reportSiteBuilderBladeError(error, {
      phase: "render",
      index: this.props.index,
      bladeType: this.props.bladeType,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return this.props.showBladeDiagnostics ? (
      <ErrorBlade
        phase="render"
        index={this.props.index}
        bladeType={this.props.bladeType}
      />
    ) : null;
  }
}
